import React from 'react';

const Footer = () => {
    return (
        <footer className="footer text-center" style={{margin:'16px 0'}}>
            &copy; 2021. All rights reserved.
        </footer>
    )
}
export default Footer;